onComplete(function() {
	// Stappenplan: the steps are plain preset items, here they become tabs with a "Stap N" button each.
	// In the editor the steps stay stacked, so every step can be edited and reordered.
	if (!document.body.hasAttribute('data-editor-mode')) {
		document.querySelectorAll('.steps').forEach(function(section, sectionIndex) {
			const list = section.querySelector('.steps-list');
			const items = list ? Array.from(list.querySelectorAll('.steps-item')) : [];
			if (items.length < 2) {
				return;
			}
			const labelElement = section.querySelector('.steps-label');
			const label = labelElement ? labelElement.textContent.trim() : '';

			const layout = document.createElement('div');
			layout.className = 'steps-layout';
			const nav = document.createElement('div');
			nav.className = 'steps-nav';
			nav.setAttribute('role', 'tablist');
			list.parentNode.insertBefore(layout, list);
			layout.appendChild(nav);
			layout.appendChild(list);

			const buttons = items.map(function(item, index) {
				const name = (label + ' ' + (index + 1)).trim();
				const id = 'steps-' + sectionIndex + '-' + index;

				const heading = document.createElement('div');
				heading.className = 'steps-item-heading h3';
				heading.textContent = name;
				item.insertBefore(heading, item.firstChild);
				item.id = id;
				item.setAttribute('role', 'tabpanel');

				const button = document.createElement('button');
				button.type = 'button';
				button.textContent = name;
				button.setAttribute('role', 'tab');
				button.setAttribute('aria-controls', id);
				button.addEventListener('click', function() {
					select(index);
				});
				nav.appendChild(button);
				return button;
			});

			function select(active) {
				items.forEach(function(item, index) {
					item.hidden = index !== active;
					buttons[index].setAttribute('aria-selected', index === active ? 'true' : 'false');
				});
			}
			select(0);
		});
	}
});
